// we will add other channels once we start supporting them
export var ConversationChannelType;
(function (ConversationChannelType) {
    /**
     * For cases when we cannot form a valid channel
     * Initial use case - to cover data associated with deleted users migrated from Zendesk
     */
    ConversationChannelType["Unknown"] = "unknown";
    ConversationChannelType["Chat"] = "chat";
    ConversationChannelType["Email"] = "email";
    ConversationChannelType["Phone"] = "phone";
    ConversationChannelType["TwilioSMS"] = "twilio-sms";
})(ConversationChannelType || (ConversationChannelType = {}));
export var ConversationParticipantEntity;
(function (ConversationParticipantEntity) {
    ConversationParticipantEntity["Unknown"] = "unknown";
    ConversationParticipantEntity["Client"] = "client";
    ConversationParticipantEntity["PlatformUser"] = "platform_user";
    ConversationParticipantEntity["Bot"] = "bot";
    ConversationParticipantEntity["Rsm"] = "rsm";
})(ConversationParticipantEntity || (ConversationParticipantEntity = {}));
export var ConversationBot;
(function (ConversationBot) {
    ConversationBot["PortalBot"] = "portal_bot";
    // Will add other bots here
})(ConversationBot || (ConversationBot = {}));
export var ConversationStatus;
(function (ConversationStatus) {
    ConversationStatus["New"] = "new";
    ConversationStatus["Open"] = "open";
    ConversationStatus["Snoozed"] = "snoozed";
    ConversationStatus["OnHold"] = "on_hold";
    ConversationStatus["Solved"] = "solved";
    ConversationStatus["Closed"] = "closed";
})(ConversationStatus || (ConversationStatus = {}));
export const CONVERSATION_STATUS_LABELS = {
    [ConversationStatus.New]: 'New',
    [ConversationStatus.Open]: 'Open',
    [ConversationStatus.Snoozed]: 'Snoozed',
    [ConversationStatus.OnHold]: 'On Hold',
    [ConversationStatus.Solved]: 'Solved',
    [ConversationStatus.Closed]: 'Closed',
};
export var ConversationChatApp;
(function (ConversationChatApp) {
    ConversationChatApp["ClientGateway"] = "client_gateway";
    ConversationChatApp["Portal"] = "portal";
})(ConversationChatApp || (ConversationChatApp = {}));
export var ConversationParticipationMode;
(function (ConversationParticipationMode) {
    /** default mode */
    ConversationParticipationMode["Engage"] = "engage";
    /** Internal mode: agents will have this mode   */
    ConversationParticipationMode["Assist"] = "assist";
})(ConversationParticipationMode || (ConversationParticipationMode = {}));
export var ConversationMessageDispatchStatus;
(function (ConversationMessageDispatchStatus) {
    ConversationMessageDispatchStatus["Dispatching"] = "dispatching";
    ConversationMessageDispatchStatus["Dispatched"] = "dispatched";
    ConversationMessageDispatchStatus["Failed"] = "failed";
    ConversationMessageDispatchStatus["Seen"] = "seen";
})(ConversationMessageDispatchStatus || (ConversationMessageDispatchStatus = {}));
export var ConversationEmailDirection;
(function (ConversationEmailDirection) {
    ConversationEmailDirection["Incoming"] = "incoming";
    ConversationEmailDirection["Outgoing"] = "outgoing";
})(ConversationEmailDirection || (ConversationEmailDirection = {}));
export var HealthStatus;
(function (HealthStatus) {
    HealthStatus["healthy"] = "healthy";
    HealthStatus["not_reachable"] = "not_reachable";
})(HealthStatus || (HealthStatus = {}));
export var SendUnlessConditionType;
(function (SendUnlessConditionType) {
    SendUnlessConditionType["AgentReply"] = "agent_reply";
    SendUnlessConditionType["ClientReply"] = "client_reply";
    SendUnlessConditionType["StatusChange"] = "status_change";
    SendUnlessConditionType["AssigneeChange"] = "assignee_change";
})(SendUnlessConditionType || (SendUnlessConditionType = {}));
export var ConversationDraftSendOptionSection;
(function (ConversationDraftSendOptionSection) {
    ConversationDraftSendOptionSection["SendAnd"] = "send-and";
    ConversationDraftSendOptionSection["SendLater"] = "send-later";
})(ConversationDraftSendOptionSection || (ConversationDraftSendOptionSection = {}));
export var ConversationDraftSideEffectActionType;
(function (ConversationDraftSideEffectActionType) {
    ConversationDraftSideEffectActionType["Status"] = "status";
    ConversationDraftSideEffectActionType["Snooze"] = "snooze";
})(ConversationDraftSideEffectActionType || (ConversationDraftSideEffectActionType = {}));
export var ConversationDraftScope;
(function (ConversationDraftScope) {
    ConversationDraftScope["Unscheduled"] = "unscheduled";
    ConversationDraftScope["Scheduled"] = "scheduled";
})(ConversationDraftScope || (ConversationDraftScope = {}));
